function bulkBuy() {
  this.addToCart = (e) => {
    let productId = e.currentTarget.dataset.productId;
    let bulkForm = $(`#${productId}--bulk-form`).serializeArray();
    let payLoad = [];
    for (let i = 0; i < bulkForm.length; i++) {
      if (Number(bulkForm[i].value) > 0) {
        payLoad.push({
          quantity: Number(bulkForm[i].value),
          id: Number(bulkForm[i].name),
          properties: {
            '_bulk-buy': true
          },
        });
      }
    }
    jQuery.post(
      "/cart/add.js",
      {
        items: payLoad,
      },
      function () {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
        document.getElementById("mini-cart").open = true;
      }
    );
  };

  this.addToCartModal = (e) => {
    let productId = e.currentTarget.dataset.productId;
    let bulkForm = $(`#${productId}--bulk-form`).serializeArray();
    let payLoad = [];
    for (let i = 0; i < bulkForm.length; i++) {
      if (Number(bulkForm[i].value) > 0) {
        payLoad.push({
          quantity: Number(bulkForm[i].value),
          id: Number(bulkForm[i].name),
        });
      }
    }
    jQuery.post(
      "/cart/add.js",
      {
        items: payLoad,
      },
      function () {
        $(e.currentTarget).closest(".bulk-buy-modal").removeAttr("open");
        $("#bulk-buy-shadow").removeAttr("open");
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
        document.getElementById("mini-cart").open = true;
      }
    );
  };

  this.inputLimiter = (e) => {
    let max = Number($(e.currentTarget).attr("max"));
    if (
      $(e.currentTarget).val() > max &&
      e.keyCode !== 46 && // keycode for delete
      e.keyCode !== 8 // keycode for backspace
    ) {
      e.preventDefault();
      $(e.currentTarget).val(max);
      $($(e.currentTarget).siblings("span")[0])
        .text(`Max: ${max}`)
        .css("visibility", "visible");
    }
  };

  this.bulkBuyDrawerTrigger = (e) => {
    let productId = $(e.currentTarget).data("product-id");
    $(`#bulk-buy-modal-${productId}`).attr("open", "");
    $("#bulk-buy-shadow").attr("open", "");
    return false;
  };

  this.closeDrawer = (e) => {
    $(e.currentTarget).closest(".bulk-buy-modal").removeAttr("open");
    $("#bulk-buy-shadow").removeAttr("open");
  };
}

(async () => {
  const Bulkbuy = new bulkBuy();
  $("#bulk_buy_add_to_cart").on("click", Bulkbuy.addToCart);
  $(document).on("click",".bulk_buy_add_to_cart", Bulkbuy.addToCartModal);
  $(document).on("keydown keyup change", ".bulk-input", Bulkbuy.inputLimiter);
  $(document).on("click", ".bulk-buy-drawer-btn", Bulkbuy.bulkBuyDrawerTrigger);
  $(document).on("click",".bulk-buy-close", Bulkbuy.closeDrawer);
})();
